import { motion } from "framer-motion";
import { Landmark, ShieldCheck, Cpu, HeartPulse, ShoppingBag, Factory, RadioTower, Zap } from "lucide-react";
import { INDUSTRIES } from "@/lib/data";

const iconMap = {
    landmark: Landmark,
    "shield-check": ShieldCheck,
    cpu: Cpu,
    "heart-pulse": HeartPulse,
    "shopping-bag": ShoppingBag,
    factory: Factory,
    "radio-tower": RadioTower,
    zap: Zap,
};

const Industries = () => (
    <section data-testid="industries-section" className="sxe-section relative bg-[#08031a]">
        <div className="sxe-container">
            <div className="max-w-3xl">
                <div className="overline"><span className="dot" /> Industries</div>
                <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-medium tracking-tighter leading-[1.05] text-white mt-5">
                    Deep expertise across{" "}
                    <span className="text-gradient">regulated and dynamic industries</span>.
                </h2>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 mt-14">
                {INDUSTRIES.map((ind, i) => {
                    const Icon = iconMap[ind.icon] || Cpu;
                    return (
                        <motion.div
                            key={ind.name}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-40px" }}
                            transition={{ duration: 0.5, delay: i * 0.04 }}
                            className="sxe-card p-6"
                            data-testid={`industry-card-${i}`}
                        >
                            <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#A100FF]/25 to-[#7B00CC]/[0.05] border border-[#C266FF]/25 flex items-center justify-center">
                                <Icon className="w-5 h-5 text-[#E9CCFF]" />
                            </div>
                            <h3 className="font-display text-white text-lg font-medium tracking-tight mt-4">{ind.name}</h3>
                            <p className="text-[#B0A3C4] text-[13.5px] leading-relaxed mt-2">{ind.desc}</p>
                        </motion.div>
                    );
                })}
            </div>
        </div>
    </section>
);

export default Industries;
